/* global axios */

import ApiClient from './ApiClient';

class CatalogSourcesAPI extends ApiClient {
  constructor() {
    super('catalog/sources', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  reimport(id) {
    return axios.post(`${this.url}/${id}/reimport`);
  }

  disconnect(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CatalogSourcesAPI();
